import { ReactNode, useState } from "react";

export function Banner(props: { children: ReactNode }) {
	const [open, setOpen] = useState(true);

	if (!open) {
		return <></>;
	}

	return (
		<div className="flex w-full items-center gap-2 bg-sesh-dark p-2 text-black">
			<button className="delete invisible" aria-hidden={true}></button>
			<div className="w-full text-center">{props.children}</div>
			<button
				className="delete ml-auto"
				onClick={() => setOpen(false)}
			></button>
		</div>
	);
}
